import RegisterPageTopSection from './components/RegisterPageTopSection'
import RegisterPageBottomSection from './components/RegisterPageBottomSection'
import Footer from './components/Footer'
import backgroundImage from '../../../assets/background.jpg'

export default function LandingPage() {
  return (
    <div
      className="mt-2 flex flex-col items-center justify-center bg-white"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}>
      <div className="flex flex-col items-center justify-center">
        <RegisterPageTopSection />
      </div>
      <div className="flex flex-col items-center justify-center">
        <RegisterPageBottomSection />
      </div>
      <Footer />
    </div>
  )
}
